<template>
  <el-input-number class="input-number" v-model="newValue" :type="type" :clearable="clearable" :style="style"
    :placeholder="i18nConfig(placeholder)" @change="change" :formatter="formatter" :parser="parser" :size="size"
    :prefix-icon="prefixIcon" :suffixIcon="suffixIcon" :rows="rows" :autosize="autosize" :autocomplete="autocomplete"
    :name="name" :readonly="readonly" :resize="resize" :precision="precision" :min="min" :max="max"
    :controls-position="controlsPosition" :controls="controls" :disabled="disabled" :maxlength="maxlength"
    :show-word-limit="showWordLimit" />
</template>
  
<script>
import { i18nConfig } from '@/utils/ruoyi'
import { reactive, toRefs, watch } from 'vue'
export default {
  name: "gljy-input-number",
  emits: ["change", "update:value"],
  props: {
    type: String,
    value: Number,
    style: {
      type: [String, Object],
      default: "width: 100%"
    },
    placeholder: String,
    maxlength: [String, Number],
    minlength: [String, Number],
    disabled: Boolean,
    showWordLimit: Boolean, // 是否显示数字
    clearable: Boolean, // 是否显示数字
    formatter: Function,
    parser: Function,
    size: String,
    resize: String,
    prefixIcon: String, // 自定义前缀图标
    suffixIcon: String, // 自定义后缀图标
    rows: Number,
    max: Number,
    min: Number,
    precision: Number,
    autosize: Boolean,
    readonly: Boolean,
    autocomplete: String,
    name: String,
    controls: Boolean,
    controlsPosition: String,
  },
  setup(props, context) {
    const datas = reactive({
      newValue: undefined,
      i18nConfig: i18nConfig
    })

    const methods = {
      change(value) {
        context.emit("update:value", value);
        context.emit("change", value);
      }
    }

    watch(() => props.value, () => {
      datas.newValue = props.value;
    }, { immediate: true })


    return {
      ...toRefs(datas),
      ...methods
    }
  }
}
</script>
  
<style lang="scss" scoped>
.input-number {
  width: 100%;
}

.file-box {
  display: flex;
  flex-wrap: wrap;

  .fileitem-box {
    width: 80px;
    height: 80px;
    margin-right: 10px;
  }
}
</style>